import { z } from "zod";

export const voiceGuesserEligibilitySchema = z.object({
	eligible: z.boolean(),
	member_count: z.number().int().nonnegative(),
});

export type VoiceGuesserEligibility = z.infer<typeof voiceGuesserEligibilitySchema>;
